import React from 'react';

import { Container, Table } from './styles';

interface Props {

}
const CustomTableSimple: React.FC<Props> = ({ children }) => {
    return <Container>
        <Table>
            {children}
        </Table>
    </Container>;
}

export default CustomTableSimple;